import { Fragment, memo } from 'react';
import { DEFAULT_AVATAR_TYPES } from '../../Constants';
import { DEFAULT_ICON_MAP } from '../defaultSvgIcons';
import { AvatarContactInitials } from './AvatarContactInitials';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const HiddenSvg = styled.svg.withConfig({
  displayName: "AvatarContent__HiddenSvg",
  componentId: "kbigpl-0"
})(["visibility:hidden;width:100%;aspect-ratio:1 / 1;"]);
const __AvatarContent = ({
  displayName,
  iconType,
  size,
  src
}) => {
  const AvatarIcon = iconType ? DEFAULT_ICON_MAP[iconType] : Fragment;
  if (src) {
    // This fixes an issue where the avatar is not visible in certain dropdowns.
    return /*#__PURE__*/_jsx(HiddenSvg, {});
  } else if (iconType === DEFAULT_AVATAR_TYPES.CONTACT) {
    return /*#__PURE__*/_jsx(AvatarContactInitials, {
      size: size,
      displayName: displayName
    });
  }
  return /*#__PURE__*/_jsx(AvatarIcon, {});
};
export const AvatarContent = /*#__PURE__*/memo(__AvatarContent);
AvatarContent.displayName = 'AvatarContent';